






































































































import Vue, { VueConstructor } from 'vue'
import VueEvents from 'vue-events'
import { Vuetable, VuetablePagination, VuetableFieldCheckbox } from 'vuetable-2'
import { config } from '@/config'
import { $token } from '@/features/api/common/request'
import TableHeader from '@/pages/common/parts/table-header/TableHeader.vue'
import TooltipCell from '@/pages/common/parts/tooltip-cell/TooltipCell.vue'
import GeneralFilter from '@/pages/common/general-filter/GeneralFilter.vue'
import ContextMenu from '@/pages/common/parts/context-menu/ContextMenu.vue'
import { ContextMenuType } from '@/pages/common/parts/context-menu/types'
import {
  $isLoading,
  requestDeleteLessons,
  $refreshPage,
  exportLessonsList,
} from '@/pages/learning/learning-lessons/list/model/learn-lessons.model'
import {
  lessonsFilters,
  lessonsPageParams,
  toggleVisibility,
  $visibility,
} from '@/pages/learning/learning-lessons/list/model/learn-lessons-filters.model'
import { reset } from '@/pages/common/general-filter/general-filter.model'
import { loadTree, $tasksTreeTotal } from '@/pages/bank/test-tasks/list/tasks-page.model'
import { noInternetToastEvent } from '@/features/toasts/toasts.model'
import {
  getLessonsActions,
  LessonsTableFields,
  searchFieldsData,
} from '@/pages/learning/learning-lessons/list/model/constants'
import { DEFAULT_ID } from '@/pages/common/constants'
import { loadConfirmDeleteModal } from '@/pages/common/modals/confirm-delete/confirm-delete-modal.model'
import { loadRequestDeleteModal } from '@/pages/common/modals/request-delete/request-delete-modal.model'
import { $permissions } from '@/features/session'
import {
  RefsType,
  HttpOptionsType,
  DisplayContextMenuPayload,
  CommonInteractedItemParams,
} from '@/pages/common/types'
import { navigatePush } from '@/features/navigation/navigationMethods'
import RequestDeleteModal from '@/pages/common/modals/request-delete/RequestDeleteModal.vue'
import ConfirmDeleteModal from '@/pages/common/modals/confirm-delete/ConfirmDeleteModal.vue'
import NoDataContent from '@/pages/common/parts/no-data-content/NoDataContent.vue'
import { combineRouteQueries, computeSortParam, isQueryParamsEquelToPage } from '@/features/lib'
import LoaderBig from '@/pages/common/parts/internal-loader-blocks/BigLoader.vue'
import { TableHeaderItem } from '@/pages/common/parts/table-header/types'
import ActionsButton from '@/pages/common/parts/actions/ActionsButton.vue'
import { showContextMenu } from '@/pages/common/parts/context-menu/context-menu.model'
import {
  changeVisibility,
  createCourse,
  editCourse,
  setArrLessonToCourse,
} from '@/pages/learning/learning-lessons/list/model/add-lessons-to-course.model'
import AddLessonsToCourseModal from '@/pages/learning/learning-lessons/list/parts/AddLessonsToCourseModal.vue'
import ToolTipFilter from '@/pages/learning/learning-lessons/list/parts/ToolTipFilter.vue'
import LessonsHeader from '@/pages/learning/learning-lessons/list/parts/LessonsHeader.vue'
import { lessonPageMounted } from './model/tooltip-filter.model'
import { Lesson } from '@/pages/learning/learning-lessons/list/model/types'
import { getActionsDisplayConditions } from '@/pages/common'
import { axiosClient } from '@/lib/request'

Vue.use(VueEvents)
Vue.component('VuetableFieldCheckbox', VuetableFieldCheckbox)

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: RefsType
    }
  >
).extend({
  name: 'LearningLessonPage',
  components: {
    Vuetable,
    VuetablePagination,
    LessonsHeader,
    TableHeader,
    GeneralFilter,
    ToolTipFilter,
    TooltipCell,
    ContextMenu,
    ActionsButton,
    NoDataContent,
    ConfirmDeleteModal,
    RequestDeleteModal,
    AddLessonsToCourseModal,
    LoaderBig,
  },
  effector: {
    $token,
    $visibility,
    $tasksTreeTotal,
    $isLoading,
    $refreshPage,
    $filterParams: lessonsFilters.store.$filterParams,
    $pageParams: lessonsPageParams.store.$pageParams,
    $treeView: lessonsPageParams.store.treeView,
    $currentPage: lessonsPageParams.store.currentPage,
    $permissions,
  },
  data() {
    return {
      interactedItemId: DEFAULT_ID,
      contextMenuType: 'item' as ContextMenuType,
      contextMenuClickedCoordinates: { x: 0, y: 0 },
      searchFields: searchFieldsData,
      fields: LessonsTableFields,
      total: 0,
      selectedRows: [] as number[],
      showDeleteModalType: 'lessons',
    }
  },
  computed: {
    apiUrl(): string {
      return `${config.BACKEND_URL}/api/lesson-app/lessons/list/`
    },
    selectedIds(): number[] {
      if (this.selectedRows.length && !this.$treeView) {
        return this.selectedRows
      }
      if (this.interactedItemId !== DEFAULT_ID) {
        return [this.interactedItemId]
      }
      return []
    },
    tableHeaderItems(): TableHeaderItem[] {
      const displayConditions = getActionsDisplayConditions('tableHeader', this.selectedRows.length)
      return getLessonsActions(displayConditions, this.$permissions!)
    },
  },
  watch: {
    $refreshPage: {
      handler(newVal) {
        if (newVal) this.$refs.vuetable.reload()
        this.removeSelection()
      },
    },
    $pageParams: {
      handler(newVal) {
        if (!isQueryParamsEquelToPage(this.$route.query, newVal)) {
          this.$router.replace(combineRouteQueries(this.$route.query, newVal))
        }
      },
    },
    $treeView: {
      handler(newVal) {
        if (newVal) this.removeSelection()
      },
    },
  },
  methods: {
    changeFilter: lessonsFilters.methods.changeFilter,
    resetFilters: lessonsFilters.methods.resetFilters,
    applyFilters: lessonsFilters.methods.applyFilters,
    toggleTreeView: lessonsPageParams.methods.toggleTreeView,
    changePage: lessonsPageParams.methods.changePage,
    queryToParams: lessonsPageParams.methods.queryToParams,
    loadTree,
    toggleVisibility,
    exportLessonsList,
    showPreview() {
      window.open(
        `${config.OLD_INTERFACE_DOMAIN}/lesson/${this.selectedIds[0]}/preview?token=${this.$token}`
      )
    },
    async myFetch(apiUrl: string, httpOptions: HttpOptionsType) {
      const request = axiosClient.get(apiUrl, {
        params: { ...httpOptions.params, sort: computeSortParam(httpOptions.params.sort) },
      })
      return request
    },
    onPaginationData(paginationData: any) {
      this.total = paginationData.total
      this.$refs.pagination.setPaginationData(paginationData)
      this.removeSelection()
    },
    onChangePage(page: any) {
      this.$refs.vuetable.changePage(page)
      this.changePage(page)
    },
    onFilterSet() {
      this.applyFilters()
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onFilterReset() {
      this.resetFilters()
      toggleVisibility(false)
      reset() // search string and field
      Vue.nextTick(() => this.$refs.vuetable.reload())
    },
    onRemoveLessons() {
      const payload = this.selectedIds
      this.showDeleteModalType = 'lessons'
      this.$permissions!.lessons_lesson_lessons.can_edit
        ? loadConfirmDeleteModal(payload)
        : loadRequestDeleteModal(payload)
    },
    onAddToCourse() {
      changeVisibility(true)
    },
    confirmAddLessonsToCourse(type: 'edit' | 'create') {
      if (type === 'edit') {
        const lessonsArr = this.$refs.vuetable.tableData.filter((lesson: Lesson) =>
          this.selectedIds.includes(lesson.id)
        )
        setArrLessonToCourse(lessonsArr)
        editCourse()
      } else {
        createCourse()
      }
    },
    onPreview(id: number) {
      navigatePush({
        name: 'create',
        query: {
          fromPage: 'list',
        },
        params: { id: `${id}` },
      })
    },
    onEditLesson() {
      const payload = this.selectedIds[0]
      const routeData = this.$router.resolve({
        name: 'edit-lesson',
        params: { id: `${payload}` },
      })
      window.open(routeData.href, '_blank')
    },
    async handleConfirmDelete(ids: number[], type: string) {
      if (type === 'lessons') {
        await requestDeleteLessons({ lessons: ids })
        this.$refs.vuetable.reload()
        this.removeSelection()
      }
    },
    async sendRequestDeleteLesson(comment: string, ids: number[]) {
      await requestDeleteLessons({ lessons: ids, ticket_comment: comment })
      this.$refs.vuetable.reload()
      this.removeSelection()
    },
    removeSelection() {
      this.$refs.vuetable.selectedTo = []
      this.selectedRows = []
    },
    handleLoadError(res: any) {
      if (!res.response) {
        noInternetToastEvent()
      }
    },
    headerActionsButtonClick(event: MouseEvent) {
      this.handleActionsClick({
        data: { id: this.selectedIds[0] },
        event,
        type: 'header-actions',
      })
    },
    tableActionsButtonClick(event: MouseEvent, id: number) {
      this.handleActionsClick({
        data: { id },
        event,
        type: 'item',
      })
    },
    handleActionsClick({ data, event, type }: CommonInteractedItemParams) {
      this.handleInteractedItemData(data)
      this.displayContextMenu({ id: data.id, type, coordinates: { x: event.x, y: event.y } })
    },
    handleRightClick({ data, event, type }: CommonInteractedItemParams) {
      event.preventDefault()
      this.handleInteractedItemData(data)
      this.displayContextMenu({ id: data.id, type, coordinates: { x: event.x, y: event.y } })
    },
    handleInteractedItemData(data: { id: number }) {
      this.interactedItemId = data.id
    },
    displayContextMenu({ id, type, coordinates: { x, y } }: DisplayContextMenuPayload) {
      this.interactedItemId = id
      this.contextMenuType = type
      this.contextMenuClickedCoordinates = { x, y }
      showContextMenu()
    },
    handleRowClick(res: any) {
      if (res.event.target.closest('.actions-activator')) return
      const { selectedTo } = this.$refs.vuetable
      if (selectedTo.length === 0) selectedTo.push(res.data.id)
      else if (selectedTo.find((el: number) => el === res.data.id)) {
        selectedTo.splice(selectedTo.indexOf(res.data.id), 1)
      } else selectedTo.push(res.data.id)
      this.selectedRows = this.$refs.vuetable.selectedTo
    },
    allToggled(isSelected: boolean) {
      if (isSelected) this.selectedRows = this.$refs.vuetable.selectedTo
      else this.selectedRows = []
    },
  },
  mounted() {
    lessonPageMounted(true)
  },
  beforeDestroy() {
    lessonPageMounted(false)
  },
  created() {
    this.queryToParams(this.$route.query)
  },
  destroyed() {
    this.resetFilters()
    changeVisibility(false)
  },
})
